export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/aadf7e204ac3ecb8628e2b693a3c4a40.svg";